export class MitelHostedPrice {
  hosted: string;
  hosted_monthly: number;
  hosted_unique: number;
  cloudLink: string;
  cloundLink_monthly: number;
  cloundLink_unique: number;
  checkCloundLink: boolean;
  mbgTeleworker: string;
  mbgTeleworker_monthly: number;
  mbgTeleworker_unique: number;
  oipCTI: string;
  oipCTI_monthly: number;
  oipCTI_unique: number;
  vpn_link: string;
  vpn_link_input: number;
  vpn_link_monthly: number;
  vpn_link_unique: number;

  totalMonthlyCost: number;
  totalUniqueCost: number;
  constructor() {
    this.hosted = 'MIVO400VA-Hosted';
    this.hosted_monthly = 7500;
    this.hosted_unique = 15000;
    this.cloudLink = 'MIVO400-CloudLink';
    this.cloundLink_monthly = 0;
    this.cloundLink_unique = 0;
    this.checkCloundLink = false;
    this.mbgTeleworker = '';
    this.mbgTeleworker_monthly = 0;
    this.mbgTeleworker_unique = 0;
    this.oipCTI = '';
    this.oipCTI_monthly = 0;
    this.oipCTI_unique = 0;
    this.vpn_link = 'Additional VP';
    this.vpn_link_input = 0;
    this.vpn_link_monthly = 0;
    this.vpn_link_unique = 0;
    this.totalMonthlyCost = 7500;
    this.totalUniqueCost = 15000;

  }
}



// WEBPACK FOOTER //
// ./src/models/MitelHostedPrice.ts